import React, { useState } from "react";
import axios from "axios";

const Login = (props) => {
  const [userId, setUserID] = useState("");
  const [pw, setPw] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Generate random number pad
  const list = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
  const pwarr = list.sort(() => Math.random() - 0.5);

  const del = () => {
    setPw(pw.substring(0, pw.length - 1));
  };

  const append = (e) => {
    setPw(pw + e.target.value);
  };

  const clear = () => {
    setPw("");
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    let data = {
      user: userId,
      pass: pw,
    };

    try {
      const res = await axios.post("http://localhost:5001/login", {
        data: data,
      });

      console.log("Login response:", res);
      
      if (res.data.length === 1) {
        props.onChange(1);
      } else {
        setError("Invalid credentials. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Please check your connection and try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="central login">
      <div className="login-header">
        <h2>Welcome to Aurora Bank</h2>
        <p>Secure Internet Banking Login</p>
      </div>

      <form onSubmit={submitHandler}>
        <div className="form-group">
          <label htmlFor="userId">User ID</label>
          <input
            type="text"
            autoComplete="off"
            id="userId"
            name="userId"
            placeholder="Enter your User ID"
            value={userId}
            onChange={(e) => setUserID(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter your password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            required
            readOnly
            disabled={isLoading}
          />
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="number-pad">
          <div className="number-pad-grid">
            {pwarr.slice(0, 3).map((num, index) => (
              <button
                key={`row1-${index}`}
                type="button"
                className="number-btn"
                value={num}
                onClick={append}
                disabled={isLoading}
              >
                {num}
              </button>
            ))}
          </div>
          <div className="number-pad-grid">
            {pwarr.slice(3, 6).map((num, index) => (
              <button
                key={`row2-${index}`}
                type="button"
                className="number-btn"
                value={num}
                onClick={append}
                disabled={isLoading}
              >
                {num}
              </button>
            ))}
          </div>
          <div className="number-pad-grid">
            {pwarr.slice(6, 9).map((num, index) => (
              <button
                key={`row3-${index}`}
                type="button"
                className="number-btn"
                value={num}
                onClick={append}
                disabled={isLoading}
              >
                {num}
              </button>
            ))}
          </div>
          <div className="number-pad-grid">
            <button
              type="button"
              className="number-btn clear-btn"
              onClick={clear}
              disabled={isLoading}
            >
              AC
            </button>
            <button
              type="button"
              className="number-btn"
              value={pwarr[9]}
              onClick={append}
              disabled={isLoading}
            >
              {pwarr[9]}
            </button>
            <button
              type="button"
              className="number-btn delete-btn"
              onClick={del}
              disabled={isLoading}
            >
              DEL
            </button>
          </div>
        </div>

        <button 
          className="subButton" 
          type="submit" 
          disabled={isLoading || !userId || !pw}
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
      </form>

      <div className="login-footer">
        <p>🔒 Your security is our priority</p>
        <p>Never share your credentials with anyone</p>
      </div>
    </div>
  );
};

export default Login;
